import _ from "lodash";
import BugReportAllInOnePage from "./BugReportAllInOnePage";
import BugReportGroupQuestions from "./BugReportGroupQuestions";

const BugReportQuestionArea = ({
  formQuestions,
  form,
  openFormId,
  onInput,
}) => {
  return (
    <BugReportGroupQuestionArea
      formQuestions={formQuestions}
      form={form}
      openFormId={openFormId}
      onInput={onInput}
    ></BugReportGroupQuestionArea>
  );
};

const BugReportGroupQuestionArea = ({
  formQuestions,
  form,
  openFormId,
  onInput,
}) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <BugReportAllInOnePage
        Scrollable={BugReportGroupScrollable}
        formQuestions={formQuestions}
        form={form}
        openFormId={openFormId}
        onInput={onInput}
      ></BugReportAllInOnePage>
    </div>
  );
};

const BugReportGroupScrollable = ({
  mainDivRef,
  handleShowScroll,
  formQuestions,
  form,
  openFormId,
  onInput,
}) => {
  return (
    <div style={{ height: "100%" }}>
      <BugReportGroupQuestions
        key={openFormId}
        openFormId={openFormId}
        formQuestions={formQuestions}
        form={form}
        mainDivRef={mainDivRef}
        handleShowScroll={handleShowScroll}
        onInput={onInput}
      ></BugReportGroupQuestions>
    </div>
  );
};

export default BugReportQuestionArea;
